exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header_1iA-7 {\n    width: 100%;\n}\n\n.radioButtonLabel_VIi2D {\n    margin-left: 2px;\n}\n", ""]);

// exports
exports.locals = {
	"header": "header_1iA-7",
	"radioButtonLabel": "radioButtonLabel_VIi2D"
};